import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useContext,
} from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Button from "../../Common/Button/Button";
import styled from "@emotion/styled";
import "./SharedJobView.css";
import { get, post } from "../../helper/Api_helper";
import {
  VYLABS_BASE_URL,
  SHOW_URL_JOB_DETAILS,
  PARSE_URL_RESUME,
} from "../../helper/url_helper";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
import { DynamicContext } from "../../Context/DynamicContext";
import experienceIcon from "../../Assets/Images/experience-icon.png";
import locationIcon from "../../Assets/Images/location_icon.png";
import salaryIcon from "../../Assets/Images/dollarIcon.png";
import JobIcon from "../../Assets/Images/jobTypeIcon.png";
import descriptionIcon from "../../Assets/Images/description-icon.svg";
import skillsIcon from "../../Assets/Images/skills-icon.svg";
import tagsIcon from "../../Assets/Images/tags-icon.svg";
import roleIcon from "../../Assets/Images/job-role-icon.svg";
import uploadIcon from "../../Assets/Images/upload-resume-icon.png";
import cepheaLogo from "../../Assets/Images/VybogTAL-Logo.svg";
import vybogTALDarkLogo from "../../Assets/Images/VybogTAL-Logo-Dark.svg";
import VybogTALLoaderAnimation from "../../Common/Dynamic-Animations/DynamicAnimations";
import ContentDialog from "../../Common/Content-Dialog/ContentDialog";
import dragAndDropIcon from "../../Assets/Images/upload.svg";
import DynamicCandidateCustomField from "../../Common/DynamicCandidateCustomField/DynamicCandidateCustomField";
import {
  applyEllipsis,
  filterPayload,
} from "../../Common/Common-Function/CommonFunctions";
import { TENANT_OTP_API_KEY } from "../../Tenant-Config/TenantConfig";

const JobDetailsContainer = styled.div`
  padding: 20px 10px;
  border-radius: 12px;
`;

const HeaderContainer = styled.div`
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 99;
  background: var(--body__background);
`;

const HeaderInner = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
`;

const HeaderLogo = styled.img`
  object-fit: contain;
`;

const FooterContainer = styled.footer`
  background-color: var(--body__background);
  padding: 20px;
  margin-top: 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  text-align: center;
`;

const FooterText = styled.p`
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
`;

const FooterLink = styled.a`
  color: #6860ee;
  text-decoration: none;
  font-weight: 500;
  &:hover {
    text-decoration: underline;
  }
`;

const SectionContainer = styled.div`
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  &:last-child {
    border-bottom: none;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 12px;
`;

const SectionTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #6860ee;
`;

const SectionIcon = styled.img`
  width: 22px;
  height: 22px;
`;
const DescriptionText = styled.p`
  margin: 0;
  line-height: 1.6;
  color: var(--job-Description_Color);
  font-size: 14px;
  white-space: pre-wrap;
  text-align: left;
`;

const SkillsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
`;

const Skill = styled.div`
  background-color: #e0deff;
  color: #2d23db;
  padding: 8px 15px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #2d23db;
    margin-right: 8px;
  }
`;

const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
`;

const Tag = styled.div`
  background-color: #efe9ff;
  color: #6f42c1;
  padding: 8px 15px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
`;
const FileUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const FileInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const FileInput = styled.input`
  display: none;
`;

const FileInputLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background-color: var(--body__background);
  border: 2px dashed #6860ee;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #6860ee;
  width: 100%;
  text-align: center;
  height: 150px;
  margin: 20px;
  justify-content: center;
  margin-bottom: 20px;
  transition: background-color 0com;
}
`;

const FileName = styled.span`
  font-size: 14px;
  color: #6a69eb;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 600;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
`;

function SharedJobView() {
  const { hashid } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [jobsList, setJobList] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const fileInputRef = useRef(null);
  const { isDarkMode } = useContext(DynamicContext);
  const [dragActive, setDragActive] = useState(false);
  const [loading, setLoading] = useState(true);
  const [customFieldValues, setCustomFieldValues] = useState({});
  const [customFieldErrors, setCustomFieldErrors] = useState({});

  const rawCustomFieldDefinitions =
    jobsList?.custom_field_definitions ||
    jobsList?.job?.custom_field_definitions ||
    [];
  const customFieldDefinitions = Array.isArray(rawCustomFieldDefinitions)
    ? rawCustomFieldDefinitions
    : [];

  const sortedCustomFieldDefinitions = [...customFieldDefinitions].sort(
    (a, b) => {
      if (a.field_type === "boolean" && b.field_type !== "boolean") return 1;
      if (a.field_type !== "boolean" && b.field_type === "boolean") return -1;
      return 0;
    },
  );

  const hasCustomFields = sortedCustomFieldDefinitions.length > 0;

  useEffect(() => {
    const id = searchParams.get("id");
    if (!id || id.trim() === "") {
      navigate("/error", { replace: true });
    } else {
      fetchJobDetails();
    }
  }, [searchParams, navigate]);

  const fetchJobDetails = async () => {
    const id = searchParams.get("id");
    setLoading(true);
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${SHOW_URL_JOB_DETAILS}?id=${id}`,
        {
          _skipAuth: true,
          headers: {
            "X-API-Key": TENANT_OTP_API_KEY,
          },
        },
      );
      setJobList(response);
    } catch (err) {
      console.error("Error in fetchJobDetails:", err);
      setJobList(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobDetails();
  }, []);
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    if (file && allowedTypes.includes(file.type)) {
      setSelectedFile(file);
    } else {
      Toast("error", "Please select a valid PDF, DOC, or DOCX file.");
      setSelectedFile(null);
      fileInputRef.current.value = "";
    }
  };

  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const files = Array.from(e.dataTransfer.files);
      const validFiles = files.filter((file) =>
        [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ].includes(file.type),
      );
      if (validFiles.length > 0) {
        setSelectedFile(validFiles[0]);
        if (validFiles.length < files.length) {
          Toast(
            "error",
            "Some files were not valid. Only PDF, DOC, or DOCX files are accepted.",
          );
        }
      } else {
        Toast(
          "error",
          "No valid files found. Please upload a PDF, DOC, or DOCX file.",
        );
      }
    }
  }, []);

  const handleDeleteFile = () => {
    setSelectedFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleCustomFieldChange = (fieldKey, value) => {
    setCustomFieldValues((previousValues) => ({
      ...previousValues,
      [fieldKey]: value,
    }));
    setCustomFieldErrors((previousErrors) => {
      if (!previousErrors[fieldKey]) return previousErrors;
      const nextErrors = { ...previousErrors };
      delete nextErrors[fieldKey];
      return nextErrors;
    });
  };

  const validateCustomFields = () => {
    const errors = {};

    sortedCustomFieldDefinitions.forEach((field) => {
      const value = customFieldValues[field.field_key];
      const isMissing =
        value === "" ||
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0);

      if (field.required && isMissing) {
        errors[field.field_key] = `${field.label || "This field"} is required`;
      }
    });

    setCustomFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleUpload = async () => {
    const id = searchParams.get("id");
    if (!selectedFile) {
      Toast("error", "Please upload a resume before submitting.");
      return;
    }
    if (!validateCustomFields()) {
      Toast("error", "Please fill all required custom fields.");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("shareId", id);
      const customFieldsPayload = filterPayload(customFieldValues);
      if (Object.keys(customFieldsPayload).length > 0) {
        formData.append("custom_fields", JSON.stringify(customFieldsPayload));
      }

      const response = await post(
        VYLABS_BASE_URL,
        PARSE_URL_RESUME,
        formData,
        {
          _skipAuth: true,
          headers: {
            "X-API-Key": TENANT_OTP_API_KEY,
          },
        },
      );
      if (response === "ok") {
        setOpenFileUpload(false);
        Toast("success", "Resume uploaded successfully!");
      }
      setSelectedFile(null);
      setCustomFieldValues({});
      setCustomFieldErrors({});
      fileInputRef.current.value = "";
    } catch (err) {
      console.error("Error uploading file:", err);
      Toast("error", "Failed to submit application.");
    }
  };

  const handleCancel = () => {
    setOpenFileUpload(false);
    setSelectedFile(null);
    setCustomFieldValues({});
    setCustomFieldErrors({});
    if (fileInputRef.current) fileInputRef.current.value = "";
  };
  return (
    <>
      <Helmet>
        <title>VybogTAL - Share Job</title>
        <meta name="description" content={jobsList?.title} />
        <meta property="og:title" content={jobsList?.title} />
        <meta property="og:description" content={jobsList?.title} />
        <meta property="og:url" content="https://app.cephea.ai/careers" />
        <meta property="og:image" content={cepheaLogo} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="VybogTAL Careers" />
      </Helmet>
      {loading ? (
        <div className="cephea-loader-container">
          <VybogTALLoaderAnimation />
        </div>
      ) : jobsList ? (
        <div className="public-job-view-container">
          <HeaderContainer>
            <HeaderInner className="header-icon-title-container">
              <a
                href="https://vybog.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <HeaderLogo
                  alt="icon"
                  src={isDarkMode ? vybogTALDarkLogo : cepheaLogo}
                />
              </a>
              <Button
                label="One Click Apply"
                backgroundColor={"#FF5D37"}
                hoverd={false}
                event={() => setOpenFileUpload(true)}
              />
            </HeaderInner>
          </HeaderContainer>
          <div style={{ margin: "0 auto", width: "80%" }}>
            <div className="jobs-details-content-container">
              <div className="jobs-side-dialog-overall-container">
                <div className="jobs-side-dialog-card-header-outer">
                  <div className="jobs-side-dialog-card-header1">
                    <div>
                      <h3
                        style={{
                          margin: "10px",
                          width: "fit-content",
                        }}
                      >
                        {jobsList?.title}
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="shared-job-info-outer-container">
                  {jobsList?.years_experience >= 0 && (
                    <div className="candidate-information">
                      <div className="info-header">
                        <img
                          src={experienceIcon}
                          alt="job-icon"
                          className="info-icon"
                        />
                        <h4 className="info-header-value">Experience</h4>
                      </div>
                      <h3 className="candidate-value">
                        {jobsList.years_experience
                          ? `${jobsList.years_experience} Years`
                          : "N/A"}
                      </h3>
                    </div>
                  )}
                  {jobsList?.location && (
                    <div className="candidate-information">
                      <div className="info-header">
                        <img
                          src={locationIcon}
                          alt="job-icon"
                          className="info-icon"
                        />
                        <h4 className="info-header-value">Location</h4>
                      </div>
                      <h3 className="candidate-value">{jobsList.location}</h3>
                    </div>
                  )}
                  {(jobsList?.salary_min || jobsList?.salary_max) && (
                    <div className="candidate-information">
                      <div className="info-header">
                        <img
                          src={salaryIcon}
                          alt="job-icon"
                          className="info-icon"
                        />
                        <h4 className="info-header-value">Salary</h4>
                      </div>
                      <h3 className="candidate-value">
                        {jobsList?.salary_min || "N/A"} -{" "}
                        {jobsList?.salary_max || "N/A"}
                      </h3>
                    </div>
                  )}
                  {jobsList?.job_type && (
                    <div className="candidate-information">
                      <div className="info-header">
                        <img
                          src={JobIcon}
                          alt="job-icon"
                          className="info-icon"
                        />
                        <h4 className="info-header-value">Job Type</h4>
                      </div>
                      <h3 className="candidate-value">{jobsList.job_type}</h3>
                    </div>
                  )}
                </div>
              </div>
              <JobDetailsContainer>
                {jobsList?.job_role && (
                  <SectionContainer>
                    <SectionHeader>
                      <SectionIcon src={roleIcon} alt="Job Role" />
                      <SectionTitle>Job Role</SectionTitle>
                    </SectionHeader>
                    <DescriptionText>{jobsList.job_role}</DescriptionText>
                  </SectionContainer>
                )}
                {jobsList?.description && (
                  <SectionContainer>
                    <SectionHeader>
                      <SectionIcon src={descriptionIcon} alt="Description" />
                      <SectionTitle>Job Description</SectionTitle>
                    </SectionHeader>
                    <DescriptionText>{jobsList.description}</DescriptionText>
                  </SectionContainer>
                )}
                {jobsList?.skills && jobsList?.skills.length > 0 && (
                  <SectionContainer>
                    <SectionHeader>
                      <SectionIcon src={skillsIcon} alt="Skills" />
                      <SectionTitle>Skills</SectionTitle>
                    </SectionHeader>
                    <SkillsContainer>
                      {jobsList.skills.split(",").map((skill, index) => (
                        <Skill key={index}>{skill.trim()}</Skill>
                      ))}
                    </SkillsContainer>
                  </SectionContainer>
                )}
                {jobsList?.tags && jobsList?.tags.length > 0 && (
                  <SectionContainer>
                    <SectionHeader>
                      <SectionIcon src={tagsIcon} alt="Tags" />
                      <SectionTitle>Tags</SectionTitle>
                    </SectionHeader>
                    <TagsContainer>
                      {jobsList.tags.map((tag, index) => (
                        <Tag key={index}>{tag}</Tag>
                      ))}
                    </TagsContainer>
                  </SectionContainer>
                )}
                <ButtonContainer>
                  <Button
                    label="One Click Apply"
                    backgroundColor={"#FF5D37"}
                    hoverd={false}
                    event={() => setOpenFileUpload(true)}
                  />
                </ButtonContainer>
              </JobDetailsContainer>
            </div>
          </div>
          <FooterContainer>
            <FooterText>
              Copyright © {new Date().getFullYear()}.All Rights Reserved By
              VybogTAL |{" "}
              <FooterLink
                href="https://vybog.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visit VybogTAL
              </FooterLink>{" "}
            </FooterText>
          </FooterContainer>
          <ContentDialog
            isOpen={openFileUpload}
            onClose={handleCancel}
            onCloseIconClose={handleCancel}
            submitButtonLabel="Submit Application"
            cancelButtonLabel={"Cancel"}
            event={handleUpload}
            contentWidth="40vw"
            // contentHeight={selectedFile ? "29.5vw" : "25.5vw"}
            title={`Apply for ( ${applyEllipsis(jobsList?.title, 80)} )`}
            overflowY={hasCustomFields}
          >
            <FileUploadContainer>
              <FileInputWrapper
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                onDragOver={handleDrag}
                onDrop={handleDrop}
              >
                <FileInput
                  type="file"
                  id="resume-upload"
                  accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                />

                <FileInputLabel htmlFor="resume-upload">
                  <div className="drag-drop-info-container">
                    <div className="inner-drag-drop-container">
                      <img
                        src={dragAndDropIcon}
                        alt="uploadIcon"
                        className="drag-and-drop-icon"
                      />
                      {dragActive
                        ? "Drop your resume here"
                        : "Drag & Drop or Click to upload resume"}
                    </div>
                    <div
                      style={{
                        marginTop: "10px",
                        fontSize: "12px",
                        color: "#666",
                        textAlign: "center",
                      }}
                    >
                      Supported formats: PDF, DOC, DOCX
                    </div>
                  </div>
                </FileInputLabel>
              </FileInputWrapper>

              {selectedFile && (
                <div
                  className="file-name-container"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    backgroundColor: "var(--body__background)",
                    borderRadius: "8px",
                    marginBottom: -"5px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={uploadIcon}
                      alt="uploadIcon"
                      style={{
                        width: "20px",
                        height: "20px",
                        marginRight: "8px",
                      }}
                    />
                    <FileName>{selectedFile.name}</FileName>
                  </div>
                  <Button
                    event={handleDeleteFile}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#ff5d37",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                    label="Remove"
                    hoverd={false}
                  />
                </div>
              )}

              {hasCustomFields && (
                <div className="shared-job-custom-fields-container">
                  {sortedCustomFieldDefinitions.map((field) => (
                    <div
                      key={field.field_key}
                      className="shared-job-custom-field"
                    >
                      <DynamicCandidateCustomField
                        entity_type={field.entity_type}
                        field_key={field.field_key}
                        label={field.label}
                        field_type={field.field_type}
                        required={field.required}
                        options={field.options}
                        value={customFieldValues[field.field_key] || ""}
                        onChange={(value) =>
                          handleCustomFieldChange(field.field_key, value)
                        }
                        canCreateTextFieldLabelStyle={{ marginBottom: "10px" }}
                        textfieldType={
                          field.field_type === "text"
                            ? "text"
                            : field.field_type === "integer" ||
                                field.field_type === "decimal"
                              ? "number"
                              : undefined
                        }
                      />
                      {customFieldErrors[field.field_key] && (
                        <div className="shared-job-custom-field-error">
                          {customFieldErrors[field.field_key]}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {/* <ButtonContainer>
                  <UploadButton
                    event={handleUpload}
                    disabled={!selectedFile || isUploading}
                    label={isUploading ? "Uploading..." : "Upload"}
                  />
                  <CancelButton
                    event={handleCancel}
                    disabled={!selectedFile}
                    label={"Cancel"}
                    isCancel={true}
                  />
                </ButtonContainer> */}
            </FileUploadContainer>
          </ContentDialog>
        </div>
      ) : null}
    </>
  );
}

export default SharedJobView;